import { render, staticRenderFns } from "./AppBase.vue?vue&type=template&id=76315b2d&scoped=true&"
import script from "./AppBase.vue?vue&type=script&lang=ts&"
export * from "./AppBase.vue?vue&type=script&lang=ts&"
import style0 from "./AppBase.vue?vue&type=style&index=0&id=76315b2d&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76315b2d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VApp,VIcon,VProgressLinear,VSpacer,VTab,VTabs,VToolbar,VToolbarTitle})
